/** `/c/$companyId/settings/chart` — the chart of accounts; anyone with access reads it. */
import type { JSX } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { ChartScreen } from "../ledger/ChartScreen";

export const Route = createFileRoute("/_auth/c/$companyId/settings/chart")({
  component: ChartRoute,
});

function ChartRoute(): JSX.Element {
  const { companyId } = Route.useParams();
  return <ChartScreen companyId={companyId} />;
}
